import { useEffect } from "preact/hooks";
import { SearchTerm } from "~/core";
import { useApp } from "~/core/store";
import type { SimplifiedSearchTerm } from "./interfaces";

const toSearchTerm = (term: SimplifiedSearchTerm) => ({
    action: {
        link: term.link,
    },
    aliases: term.aliases,
    appearance: {
        text: term.text,
        icon: term.icon,
    },
});

const useSearch = (
    initialTerms: (SearchTerm | SimplifiedSearchTerm)[],
    deps: readonly unknown[] = [],
) => {
    const {
        search: { terms },
    } = useApp();

    useEffect(() => {
        const newTerms = initialTerms.map(
            (term): SearchTerm => ("link" in term ? toSearchTerm(term) : term),
        );

        terms.value = terms.value.concat(newTerms);

        return () => {
            terms.value = terms.value.filter(
                (item) => !newTerms.includes(item),
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

export default useSearch;
